import { genericPostingActionCreator, getCookieValue } from '../../../actions/genericActionCreator'
import { catchCommonErrors } from '../../../actions/commonActionUtils'
import { fetchCurrentUser } from '../../../actions/currentUserActions'

export const clearMessages = () => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('REACTIVATE_LENDER_SERVICER', 'init'))
  }
}

export const reactivateLenderServicer = ({ type, id, pin }) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('REACTIVATE_LENDER_SERVICER', 'posting'))
    return fetch('/lgyhub/api/users/reactivate/me', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        name: type,
        id: id,
        pin: pin,
        delete: false,
        affiliationChangedIn30Days: false,
        institutionName: ''
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'reactivating your account')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {          
        dispatch(genericPostingActionCreator('REACTIVATE_LENDER_SERVICER', 'error', { 
          error: true, 
          message: responseJson.errors[0].message, 
          affiliate: { id: id, name: type }
        }))
        throw new Error(responseJson.errors[0].message)
      } else { //success
        dispatch(genericPostingActionCreator('REACTIVATE_LENDER_SERVICER', 'posted'))
        dispatch(fetchCurrentUser())
      }
    }).catch((error) => {
      console.error('Lender/servicer reactivation failed: ', error)
    })
  }
}